import axios from 'axios'
import md5 from 'md5'
import sha256 from 'sha256'
import moment from 'moment'
// const getHttp = (url, data) => {
//   return axios({
//     method: 'get',
//     url: url,
//     data
//   })
// }
// 授权模块
export const serverManageOauthNoTokenLogin = async () => {
  // console.log(process)
  return new Promise(async (resolve, reject) => {
    const code = 'RMKR1AN8HI'
    const timestamp = moment().valueOf()
    const salt = 'v9ztjyyah7d1jwzrjddv'
    const sign = md5(sha256(code + timestamp + salt))
    const { data: {data} } = await axios.post(`/sensor/oapi/server-manage-oauth/noToken/login`, { code, sign, timestamp })
    localStorage.setItem('sensorToken', data.token)
    resolve()
  })
}
export const bmsSensorFindStateByImei = async (option) => {
  const { data } = await axios.post(`/sensor/oapi/bms-sensor/find-state-by-imei`, option)
  return data
}
export const bmsSensorBmsChart = async (option) => {
  const { data } = await axios.post(`/sensor/oapi/bms-sensor/bms/chart`, option)
  return data
}
export const createDeviceComponent = async (option) => {
  const { data } = await axios.post(`/sensor/oapi/device-component`, option)
  return data
}
export const getInfoAndStatusByScanQrcode = async(sn) => {
  const {data} = await axios.get(`/v2/solar-motes/get-info-and-status-by-scan-qrcode?snHex=${sn}`)
  return data
}
// 编辑绑定的BMS
export const updateDeviceComponent = async(option) => {
  const { data } = await axios.put(`/sensor/oapi/device-component`, option)
  return data
}
// 解绑BMS
export const deleteDeviceComponent = async(id) => {
  const { data } = await axios.delete(`/sensor/oapi/device-component/${id}`)
  return data
}

// 查询绑定的BMS
export const deviceComponentFindByTargetId = async(targetId) => {
  const { data } = await axios.get(`/sensor/oapi/device-component/find-by-target-id/${targetId}`)
  return data
}
// 新增恒流恒压策略
export const strategyTemplatesVolCurrSave = async(projectId, params) => {
  const { data } = await axios.post(`/v2/strategy-templates/vol-curr-save?projectId=${projectId}`, params)
  return data
}
export const strategyTemplatesVolCurrUpdate = async(projectId, params) => {
  const { data } = await axios.put(`/v2/strategy-templates/vol-curr-update?projectId=${projectId}`, params)
  return data
}
export const strategyTemplatesVolCurrDelete = async(params) => {
  const { data } = await axios.delete(`/v2/strategy-templates/vol-curr-delete/${params}`)
  return data
}
export const deviceDownsTurnVolSwitch = async(params) => {
  const { data } = await axios.post(`/v1/device-downs/turn-vol-switch`, params)
  return data
}
export const deviceDownsTurnVolSwitchGroup = async(params) => {
  const { data } = await axios.post(`/v1/device-downs/turn-vol-switch-group`, params)
  return data
}
// 恒压，横流开关-批量
export const deviceDownsTurnVolSwitchBatch = async(params) => {
  const { data } = await axios.post(`/v1/device-downs/turn-vol-switch-batch`, params)
  return data
}
// 创建微信支付订单
export const payConfirm = async(projectId, params) => {
  const { data } = await axios.post(`/v1/solar-mote-pay/pay-confirm?projectId=${projectId}`, params)
  return data
}
// 查询充值订单
export const findPayProgress = async(query, params) => {
  const { data } = await axios.post(`v1/solar-mote-pay/find-pay-progress?projectId=${query.projectId}&pageNo=${query.currentPage}&pageSize=${query.pageSize}`, params)
  return data
}
// 取消订单
export const payCancel = async(projectId, params) => {
  const { data } = await axios.post(`/v1/solar-mote-pay/pay-cancel?projectId=${projectId}`, params)
  return data
}
// 查询设备状态数量
export const findCountStatus = async(projectId) => {
  const { data } = await axios.get(`/v1/solar-mote-pay/find-count-status?projectId=${projectId}`)
  return data
}
// 查询类型价格
export const payMoteModePrice = async(projectId) => {
  const { data } = await axios.get(`/v1/solar-mote-pay/pay-mote-mode-price?projectId=${projectId}`)
  return data
}
// bms电池电压统计图表
export const volStatisticChart = async(params) => {
  const { data } = await axios.post(`/sensor/oapi/bms-sensor/bms/vol-statistic/chart`, params)
  return data
}
export const totalEnergyMoteid = async(params) => {
  const { data } = await axios.get(`/v1/pgl/index/total-energy-moteid?projectId=${params.projectId}&moteId=${params.moteId}&date=${params.date}`, params)
  return data
}
export const bmsSensorDownSend = async(params) => {
  const { data } = await axios.post(`/sensor/oapi/bms-sensor/down-send`, params)
  return data
}

// 绑定电表和设备的关系
export const meterSaveRelation = async(projectId, params) => {
  const { data } = await axios.post(`/v1/meter/save-relation?projectId=${projectId}`, params)
  return data
}
// 编辑绑定电表和设备的关系
export const meterUpdateRelation = async(projectId, params) => {
  const { data } = await axios.post(`/v1/meter/update-relation?projectId=${projectId}`, params)
  return data
}
// 下发指令查询电表数据
export const meterStatusGetStatus = async(projectId, imei) => {
  const { data } = await axios.post(`/v1/meter-status/get-status/${imei}?projectId=${projectId}`)
  return data
}
// 查询电表和设备的绑定关系
export const meterFindRelation = async(projectId, params) => {
  const { data } = await axios.post(`/v1/meter/update-relation?projectId=${projectId}`, params)
  return data
}
// 解除电表和设备的关系
export const meterRelieveRelation = async(projectId, imei) => {
  const { data } = await axios.post(`/v1/meter/relieve-relation?projectId=${projectId}`, {imei})
  return data
}
// 查询电表的状态数据
export const meterStatusFindStatus = async(projectId, imei) => {
  const { data } = await axios.get(`/v1/meter-status/find-status/${imei}?projectId=${projectId}`)
  return data
}
// 查询电表历史数据集合
export const meterStatusFindStatusHis = async(params) => {
  const { data } = await axios.get(`/v1/meter-status/find-status-his?beginDate=${params.beginDate}&endDate=${params.endDate}&statusId=${params.statusId}`)
  return data
}
// 查询电表列表
export const meterFindMeterList = async(projectId) => {
  const { data } = await axios.get(`/v1/meter/find-meter-list?projectId=${projectId}`)
  return data
}
// 查询设备列表
export const solarMotesPagi = async(projectId) => {
  const { data } = await axios.get(`/v2/solar-motes/pagi?projectId=${projectId}&pageNo=${1}&pageSize=${1000}`)
  return data
}
// 查询当前项目下所有被绑定过的设备
export const meterFindAllRelation = async(projectId) => {
  const { data } = await axios.get(`/v1/meter/find-all-relation?projectId=${projectId}`)
  return data
}
